import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CoachlogSearchPayloadItemsDTO } from 'src/app/common/dtos/coachlog-search-payload.dto';
import { dateTimeFromNgbDate } from 'src/app/common/utilities/date-helpers';
import { TopicSearchParams } from 'src/app/private/pages/topics-page/topics-page-helpers';
import { CelebrationFilterDTO } from '../../dtos/celebrations.dto';
import { PdListFilterDTO } from '../../dtos/pd.dto';
import { PdCategoryOptionFilter } from '../modals/pd-filter-modal/pd-filter-modal.component';
import { FilterList, FilterType } from './applied-filters.dto';

@Component({
  selector: 'app-applied-filters',
  templateUrl: './applied-filters.component.html',
  styleUrls: ['./applied-filters.component.scss'],
  standalone: false,
})
export class AppliedFiltersComponent implements OnChanges {
  // Add more Payload DTOs as needed, and display them separately in template
  @Input() coachlogSearchOptions: CoachlogSearchPayloadItemsDTO;

  @Input() celebrationSearchOptions: CelebrationFilterDTO;

  @Input() topicPageSearchOptions: TopicSearchParams;

  @Input() pdListSearchOptions: PdListFilterDTO;

  @Input() filterType: string;

  @Input() canSeeAllSchools: boolean;

  @Input() showEditFiltersBtn = false;

  @Input() pdCategoryOptions: PdCategoryOptionFilter[] = [];

  @Output() readonly filterRemoved: EventEmitter<string> = new EventEmitter();

  @Output() readonly filterListRemoved: EventEmitter<FilterList> =
    new EventEmitter();

  @Output() readonly openModal: EventEmitter<boolean> = new EventEmitter();

  @Input() dateChange: NgbDate | null;

  celebrationFromDate: number;

  celebrationToDate: number;

  pdFromDate: number | null;

  pdToDate: number | null;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['dateChange'] &&
      this.celebrationSearchOptions?.fromDate &&
      this.celebrationSearchOptions?.toDate
    ) {
      this.celebrationFromDate = dateTimeFromNgbDate(
        this.celebrationSearchOptions.fromDate
      ).toSeconds();
      this.celebrationToDate = dateTimeFromNgbDate(
        this.celebrationSearchOptions.toDate
      ).toSeconds();
    } else if (
      this.pdListSearchOptions?.from_date &&
      this.pdListSearchOptions?.to_date
    ) {
      this.pdFromDate = dateTimeFromNgbDate(
        this.pdListSearchOptions.from_date
      ).toSeconds();
      this.pdToDate = dateTimeFromNgbDate(
        this.pdListSearchOptions.to_date
      ).toSeconds();
    }
  }

  removeFilter(keyName: string) {
    this.filterRemoved.emit(keyName);
  }

  removeFilterFromList(keyName: string, value: FilterType) {
    this.filterListRemoved.emit({
      keyName,
      value,
    });
  }
}
